<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeThisModal()" />
</div>

<ion-content>
  <div>
    <ion-grid class="brukerkunde-grid">
      <ion-row>
        <ion-col>
          <!-- Kundetilganger -->
          <ion-title class="smaller">
            <h1>Kunde&#173;tilganger</h1>
          </ion-title>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-block">
          <p>Du er registrert med tilgang til følgende kundeforhold:</p>
        </ion-col>
      </ion-row>

      <ion-row
        class="ion-margin-bottom pointer"
        *ngFor="let kunde of brukerkundeResponse"
        (click)="changeKunde(kunde.kunde_id)"
      >
        <ion-col
          class="p-block withHoverColor brukerkundeboks"
          size="12"
          sizeMd="8"
          offsetMd="2"
          [class.brukerkundeboksselected]="kunde.kunde_id === kundeIdFromKC"
        >
          <p class="bold-name">{{kunde.navn}}</p>
          <p class="small-text">Kundenr: {{kunde.kunde_id}}</p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <p class="small-text grey" *ngIf="brukerkundeResponse?.length > 1">
            Trykk for å bytte aktivt kundeforhold
          </p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="tildelte?.length > 0">
        <ion-col class="m-block">
          <p>Du har delt tilgang til:</p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="tildelte?.length > 0">
        <ion-col>
          <ion-row *ngFor="let kunde of tildelte" class="ion-margin-bottom">
            <ion-col class="delttilgangboks" size="12" sizeMd="8" offsetMd="2">
              <ion-row>
                <ion-col size="11" class="p-block">
                  <p class="bold-name">{{kunde.tildeltTilNavn}}</p>
                  <p class="small-text">Kundenr: {{kunde.kunde_id}}</p>
                </ion-col>
                <ion-col
                  size="1"
                  class="flex-trash pointer"
                  title="Fjern tilgang"
                  (click)="unshare(kunde.userId)"
                >
                  <ion-icon
                    name="trash-outline"
                    class="revokeAccess"
                  ></ion-icon>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="m-block">
          <p>Del aktivt kundeforhold med:</p>
        </ion-col>
      </ion-row>
      <form [formGroup]="shareGroup" novalidate class="form-input-ihk">
        <ion-row>
          <ion-col size="12" sizeMd="8" offsetMd="2">
            <ion-input
              label="E-post"
              labelPlacement="stacked"
              fill="outline"
              placeholder="eksempel@eksempel.no"
              type="email"
              inputmode="email"
              formControlName="epost"
            >
            </ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" sizeMd="8" offsetMd="2">
            <ion-button
              class="dark wide"
              strong="true"
              [disabled]="!shareGroup.valid || inUse?.tildelt"
              (click)="share()"
              >Del tilgang</ion-button
            >
            <span *ngIf="inUse?.tildelt"
              >Kan ikke dele dette kundeforholdet</span
            >
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </div>
</ion-content>
